import { createSelector } from '@ngrx/store';
import { AppStateInterface } from 'src/app/appState.interface';
import { ListTabRefInterface } from './interface/tabFilterRef.interface';
import { MAX_ASSETS_LOAD } from '../config/config.constants';

export const selectCustomersFeature = (state: AppStateInterface) =>
  state.getCustomers;
export const selectVehicleFeature = (state: AppStateInterface) =>
  state.getVehiclesOfCustomers;
export const selectFleetFeature = (state: AppStateInterface) =>
  state.getFleetsOfCustomers;
export const selectDriverFeature = (state: AppStateInterface) =>
  state.getDriversOfCustomers;
export const selectTeamsFeature = (state: AppStateInterface) =>
  state.getTeamsOfCustomers;
export const selectSelectedCustomerFeature = (state: AppStateInterface) =>
  state.setSelectedCustomerCache;
export const setTabFilterRefFeature = (state: ListTabRefInterface) => state;
export const selectTabFilterRefFeature = (state: AppStateInterface) =>
  state.setTabFilterRef;
export const selectTabAssetChooserRefFeature = (state: AppStateInterface) =>
  state.setTabAssetChooserRef;
export const selectUserFeature = (state: AppStateInterface) => state.user;
export const selectApplySelectedUidCustomer = (state: AppStateInterface) =>
  state.applySelectedCustomer;
export const selectSelectedAssets = (state: AppStateInterface) =>
  state.setSelectedAssets;
export const selectApplySelectedAssets = (state: AppStateInterface) =>
  state.applySelectedAssets;
export const selectSelectedPeriod = (state: AppStateInterface) =>
  state.setSelectedPeriod;
export const selectApplySelectedPeriod = (state: AppStateInterface) =>
  state.applySelectedPeriod;
export const selectCompleteState = (state: AppStateInterface) =>
  state.completeApplyState;
export const selectFilterRefSetting = (state: AppStateInterface) =>
  state.filterRefSetting;
export const selectVehicleFilters = (state: AppStateInterface) =>
  state.vehicleFilters;
export const selectDashboards = (state: AppStateInterface) =>
  state.dashboards.dashboards;
export const selectDashboardData = (state: AppStateInterface) =>
  state.dashboardData;

//Customers
export const isLoadingCustomersSelector = createSelector(
  selectCustomersFeature,
  (state) => state.isLoading
);

export const getCustomersSelector = createSelector(
  selectCustomersFeature,
  (state) => state?.posts || []
);

export const errorCustomersSelector = createSelector(
  selectCustomersFeature,
  (state) => state?.error || null
);

// Vehicle of Customers
export const isLoadingVehiclesOfCustomersSelector = createSelector(
  selectVehicleFeature,
  (state) => state.isLoading
);

// Selector filtrato: restituisce solo veicoli con isChild=false o undefined (usato dalla maggior parte delle pagine)
export const getVehiclesOfCustomersSelector = createSelector(
  selectVehicleFeature,
  (state) => (state?.posts || []).filter((vehicle: any) =>
    !vehicle.isChild &&

    vehicle.dataHidden === false
  )
);
// Selector completo: restituisce tutti i veicoli inclusi isChild=true (usato da actia-map e pagine che richiedono tutti gli asset)
export const getVehiclesOfCustomersSelectorAllAssets = createSelector(
  selectVehicleFeature,
  (state) => state?.posts || []
);

export const errorVehiclesOfCustomersSelector = createSelector(
  selectVehicleFeature,
  (state) => state?.error || null
);

// Fleet of Customers
export const isLoadingFleetsOfCustomersSelector = createSelector(
  selectFleetFeature,
  (state) => state.isLoading
);

export const getFleetsOfCustomersSelector = createSelector(
  selectFleetFeature,
  (state) => state?.posts || []
);

export const errorFleetsOfCustomersSelector = createSelector(
  selectFleetFeature,
  (state) => state?.error || null
);

// Driver of Customers
export const isLoadingDriversOfCustomersSelector = createSelector(
  selectDriverFeature,
  (state) => state.isLoading
);

// Selector filtrato: restituisce solo driver con isChild=false o undefined (usato dalla maggior parte delle pagine)
export const getDriversOfCustomersSelector = createSelector(
  selectDriverFeature,
  (state) => state?.posts || []
);

// Selector completo: restituisce tutti i driver inclusi isChild=true (usato da actia-map e pagine che richiedono tutti gli asset)
export const getDriversOfCustomersSelectorAllAssets = createSelector(
  selectDriverFeature,
  (state) => state?.posts || []
);

export const errorDriversOfCustomersSelector = createSelector(
  selectDriverFeature,
  (state) => state?.error || null
);

// Teams of Customers
export const isLoadingTeamsOfCustomersSelector = createSelector(
  selectTeamsFeature,
  (state) => state.isLoading
);

export const getTeamsOfCustomersSelector = createSelector(
  selectTeamsFeature,
  (state) => state?.posts || []
);

export const errorTeamsOfCustomersSelector = createSelector(
  selectTeamsFeature,
  (state) => state?.error || null
);

//Selected Customer
export const selectedCustomerNameSelector = createSelector(
  selectSelectedCustomerFeature,
  (state) => state.name
);

export const selectedCustomerUidSelector = createSelector(
  selectSelectedCustomerFeature,
  (state) => state.uid
);

export const selectedCustomerSelector = createSelector(
  selectSelectedCustomerFeature,
  (state) => state
);

//set TabFilterRef

export const setTabFilterRefSelector = createSelector(
  setTabFilterRefFeature,
  (state) => state.tabFilterRef
);

export const getTabFilterRefSelector = createSelector(
  selectTabFilterRefFeature,
  (state) => state
);

//set TabAssetChooserRef

export const setTabAssetChooserRefSelector = createSelector(
  selectTabAssetChooserRefFeature,
  (state) => state.tabFilterRef
);

export const getTabAssetChooserRefSelector = createSelector(
  selectTabAssetChooserRefFeature,
  (state) => state
);

export const getUser = createSelector(selectUserFeature, (state) => state);
export const getApplySelectedCustomer = createSelector(
  selectApplySelectedUidCustomer,
  (state) => state
);

// Selector filtrato: restituisce solo asset con isChild=false o undefined (usato dalla maggior parte delle pagine)
// Per i driver (assetType === 'DRIVR') non applica filtri
export const getSelectedAssests = createSelector(
  selectSelectedAssets,
  (state) => {
    if (!state || !state.selected) return state;

    // Se è un driver, non applicare filtri
    if (state.assetType === 'DRIVR') {
      return state;
    }

    // Altrimenti applica i filtri per i veicoli
    return {
      ...state,
      selected: state.selected.filter(asset =>
        !asset.isChild &&

        asset.dataHidden === false
      ),
      totSelected: state.selected.filter(asset =>
        !asset.isChild &&

        asset.dataHidden === false
      ).length
    };
  }
);

// Selector completo: restituisce tutti gli asset inclusi isChild=true (usato da actia-map e pagine che richiedono tutti gli asset)
export const getSelectedAssestsAllAssets = createSelector(
  selectSelectedAssets,
  (state) => state
);

export const getApplySelectedAssests = createSelector(
  selectApplySelectedAssets,
  (state) => state
);

export const getTabAssetDefaultAssetType = createSelector(
  selectTabAssetChooserRefFeature,
  (state) => state.defaultAssetType
);

export const getApplySelectedAssetTot = createSelector(
  selectApplySelectedAssets,
  (state) => state.totSelected
);

export const getSelectedPeriod = createSelector(
  selectSelectedPeriod,
  (state) => state
);

export const getApplySelectedPeriod = createSelector(
  selectApplySelectedPeriod,
  (state) => state
);

export const isApplySelectedAsset = createSelector(
  selectApplySelectedAssets,
  (state) => state.isApply
);

// Selettori per filtrare assets da setSelectedAssets
export const getSelectedAssetsByChild = (isChild: boolean) => createSelector(
  selectSelectedAssets,
  (state) => state?.selected?.filter(asset => asset.isChild === isChild) || []
);

export const getSelectedAssetsBySubscribed = (subscribed: boolean) => createSelector(
  selectSelectedAssets,
  (state) => state?.selected?.filter(asset => asset.subscribed === subscribed) || []
);

export const getSelectedAssetsByDisabled = (disabled: boolean) => createSelector(
  selectSelectedAssets,
  (state) => state?.selected?.filter(asset => asset.disabled === disabled) || []
);

export const getSelectedAssetsByHaveCommunicated = (haveCommunicated: boolean) => createSelector(
  selectSelectedAssets,
  (state) => state?.selected?.filter(asset => asset.haveCommunicated === haveCommunicated) || []
);

export const getSelectedAssetsByDataHidden = (dataHidden: boolean) => createSelector(
  selectSelectedAssets,
  (state) => state?.selected?.filter(asset => asset.dataHidden === dataHidden) || []
);

// Selettori per filtrare assets da applySelectedAssets
export const getApplySelectedAssetsByChild = (isChild: boolean) => createSelector(
  selectApplySelectedAssets,
  (state) => state?.selected?.filter(asset => asset.isChild === isChild) || []
);

export const getApplySelectedAssetsBySubscribed = (subscribed: boolean) => createSelector(
  selectApplySelectedAssets,
  (state) => state?.selected?.filter(asset => asset.subscribed === subscribed) || []
);

export const getApplySelectedAssetsByDisabled = (disabled: boolean) => createSelector(
  selectApplySelectedAssets,
  (state) => state?.selected?.filter(asset => asset.disabled === disabled) || []
);

export const getApplySelectedAssetsByHaveCommunicated = (haveCommunicated: boolean) => createSelector(
  selectApplySelectedAssets,
  (state) => state?.selected?.filter(asset => asset.haveCommunicated === haveCommunicated) || []
);

export const getApplySelectedAssetsByDataHidden = (dataHidden: boolean) => createSelector(
  selectApplySelectedAssets,
  (state) => state?.selected?.filter(asset => asset.dataHidden === dataHidden) || []
);

// Selettori per filtrare assets da completeApplyState.applySelectedAssets
export const getCompleteStateApplyAssetsByChild = (isChild: boolean) => createSelector(
  selectCompleteState,
  (state) => state?.applySelectedAssets?.selected?.filter(asset => asset.isChild === isChild) || []
);

export const getCompleteStateApplyAssetsBySubscribed = (subscribed: boolean) => createSelector(
  selectCompleteState,
  (state) => state?.applySelectedAssets?.selected?.filter(asset => asset.subscribed === subscribed) || []
);

export const getCompleteStateApplyAssetsByDisabled = (disabled: boolean) => createSelector(
  selectCompleteState,
  (state) => state?.applySelectedAssets?.selected?.filter(asset => asset.disabled === disabled) || []
);

export const getCompleteStateApplyAssetsByHaveCommunicated = (haveCommunicated: boolean) => createSelector(
  selectCompleteState,
  (state) => state?.applySelectedAssets?.selected?.filter(asset => asset.haveCommunicated === haveCommunicated) || []
);

export const getCompleteStateApplyAssetsByDataHidden = (dataHidden: boolean) => createSelector(
  selectCompleteState,
  (state) => state?.applySelectedAssets?.selected?.filter(asset => asset.dataHidden === dataHidden) || []
);

// Selettori combinati per filtrare con più criteri
export const getSelectedAssetsFiltered = (filters: {
  isChild?: boolean,
  subscribed?: boolean,
  disabled?: boolean,
  haveCommunicated?: boolean,
  dataHidden?: boolean
}) => createSelector(
  selectSelectedAssets,
  (state) => {
    let assets = state?.selected || [];
    if (filters.isChild !== undefined) {
      assets = assets.filter(asset => asset.isChild === filters.isChild);
    }
    if (filters.subscribed !== undefined) {
      assets = assets.filter(asset => asset.subscribed === filters.subscribed);
    }
    if (filters.disabled !== undefined) {
      assets = assets.filter(asset => asset.disabled === filters.disabled);
    }
    if (filters.haveCommunicated !== undefined) {
      assets = assets.filter(asset => asset.haveCommunicated === filters.haveCommunicated);
    }
    if (filters.dataHidden !== undefined) {
      assets = assets.filter(asset => asset.dataHidden === filters.dataHidden);
    }
    return assets;
  }
);

export const getApplySelectedAssetsFiltered = (filters: {
  isChild?: boolean,
  subscribed?: boolean,
  disabled?: boolean,
  haveCommunicated?: boolean,
  dataHidden?: boolean
}) => createSelector(
  selectApplySelectedAssets,
  (state) => {
    let assets = state?.selected || [];
    if (filters.isChild !== undefined) {
      assets = assets.filter(asset => asset.isChild === filters.isChild);
    }
    if (filters.subscribed !== undefined) {
      assets = assets.filter(asset => asset.subscribed === filters.subscribed);
    }
    if (filters.disabled !== undefined) {
      assets = assets.filter(asset => asset.disabled === filters.disabled);
    }
    if (filters.haveCommunicated !== undefined) {
      assets = assets.filter(asset => asset.haveCommunicated === filters.haveCommunicated);
    }
    if (filters.dataHidden !== undefined) {
      assets = assets.filter(asset => asset.dataHidden === filters.dataHidden);
    }
    return assets;
  }
);

export const getCompleteStateApplyAssetsFiltered = (filters: {
  isChild?: boolean,
  subscribed?: boolean,
  disabled?: boolean,
  haveCommunicated?: boolean,
  dataHidden?: boolean
}) => createSelector(
  selectCompleteState,
  (state) => {
    let assets = state?.applySelectedAssets?.selected || [];
    if (filters.isChild !== undefined) {
      assets = assets.filter(asset => asset.isChild === filters.isChild);
    }
    if (filters.subscribed !== undefined) {
      assets = assets.filter(asset => asset.subscribed === filters.subscribed);
    }
    if (filters.disabled !== undefined) {
      assets = assets.filter(asset => asset.disabled === filters.disabled);
    }
    if (filters.haveCommunicated !== undefined) {
      assets = assets.filter(asset => asset.haveCommunicated === filters.haveCommunicated);
    }
    if (filters.dataHidden !== undefined) {
      assets = assets.filter(asset => asset.dataHidden === filters.dataHidden);
    }
    return assets;
  }
);

export const getCompleteState = createSelector(
  selectCompleteState,
  (state) => {
    if (!state || !state.applySelectedAssets) return state;

    // Se è un driver, non applicare filtri
    if (state.applySelectedAssets.assetType === 'DRIVR') {
      return state;
    }

    // Altrimenti applica i filtri per i veicoli
    const filteredAssets = state.applySelectedAssets.selected?.filter(asset =>
      !asset.isChild &&
      asset.dataHidden === false

    ) || [];

    // Applica il limite MAX_ASSETS_LOAD
    const isCapped = filteredAssets.length > MAX_ASSETS_LOAD;
    const cappedAssets = filteredAssets.slice(0, MAX_ASSETS_LOAD);

    return {
      ...state,
      isCapped,
      applySelectedAssets: {
        ...state.applySelectedAssets,
        selected: cappedAssets,
        totSelected: cappedAssets.length
      }
    };
  }
);

// export const getCompleteState = createSelector(
//   selectCompleteState,
//   selectVehicleFeature,
//   (state, vehiclesState) => {
//     if (!state || !state.applySelectedAssets) return state;

//     // Se è un driver, non applicare filtri
//     if (state.applySelectedAssets.assetType === 'DRIVR') {
//       return state;
//     }

//     // Prende TUTTI i veicoli freschi da getVehiclesOfCustomers (source of truth)
//     const freshVehicles = vehiclesState?.posts || [];

//     // Set degli uid selezionati dall'utente (da applySelectedAssets nello store)
//     const selectedUids = new Set(
//       (state.applySelectedAssets.selected || []).map((a: any) => a.uid)
//     );

//     console.log('[getCompleteState] selectedUids count:', selectedUids.size);
//     console.log('[getCompleteState] freshVehicles count:', freshVehicles.length);

//     // Filtra i veicoli freschi: selezionato dall'utente && !isChild && dataHidden === false
//     const filteredAssets = freshVehicles.filter((v: any) => {
//       if (!selectedUids.has(v.uid)) return false;
//       const pass = !v.isChild && v.dataHidden === false;
//       if (!pass) {
//         console.log('[getCompleteState] escluso:', v.text, '| isChild:', v.isChild, '| dataHidden:', v.dataHidden);
//       }
//       return pass;
//     });

//     console.log('[getCompleteState] dopo filtro fresh:', filteredAssets.length);

//     // Applica il limite MAX_ASSETS_LOAD
//     const isCapped = filteredAssets.length > MAX_ASSETS_LOAD;
//     const cappedAssets = filteredAssets.slice(0, MAX_ASSETS_LOAD);

//     console.log('[getCompleteState] isCapped:', isCapped, '| finale:', cappedAssets.length);

//     return {
//       ...state,
//       isCapped,
//       applySelectedAssets: {
//         ...state.applySelectedAssets,
//         selected: cappedAssets,
//         totSelected: cappedAssets.length
//       }
//     };
//   }
// );

// Selector: restituisce completeApplyState con tutti gli asset (anche isChild=true)
export const getCompleteStateAllAssets = createSelector(
  selectCompleteState,
  (state) => {
    if (!state || !state.applySelectedAssets) return state;

    const allAssets = state.applySelectedAssets.selected || [];

    // Applica il limite MAX_ASSETS_LOAD
    const isCapped = allAssets.length > MAX_ASSETS_LOAD;
    const cappedAssets = allAssets.slice(0, MAX_ASSETS_LOAD);

    return {
      ...state,
      isCapped,
      applySelectedAssets: {
        ...state.applySelectedAssets,
        selected: cappedAssets,
        totSelected: cappedAssets.length
      }
    };
  }
);

export const getCompleteStateIncludeChildrens = createSelector(
  selectCompleteState,
  (state) => state.includeChildrens
);

export const getFitlerRefSetting = createSelector(
  selectFilterRefSetting,
  (state) => state
);

export const getFitlerRefSettingIsSetting = createSelector(
  selectFilterRefSetting,
  (state) => state.isSetting
);

export const getFitlerRefSettingShowFilter = createSelector(
  selectFilterRefSetting,
  (state) => state.showFilter
);

export const getFitlerRefSettingShowDetailAssets = createSelector(
  selectFilterRefSetting,
  (state) => state.showDetailAssets
);

export const getFitlerRefSettingShowStaticCustomerLabel = createSelector(
  selectFilterRefSetting,
  (state) => !!state.showStaticCustomerLabel
);

export const getFitlerRefSettingIncludeChildrens = createSelector(
  selectFilterRefSetting,
  (state) => state.showIncludeChildrens
);

// Selector filtrato: restituisce il conteggio dei veicoli con isChild=false o undefined
export const getTotVehicles = createSelector(
  selectVehicleFeature,
  (state) => (state?.posts || []).filter((vehicle: any) =>
    !vehicle.isChild &&
    vehicle.dataHidden === false
  ).length
);

// Selector completo: restituisce il conteggio di tutti i veicoli inclusi isChild=true
export const getTotVehiclesAllAssets = createSelector(
  selectVehicleFeature,
  (state) => state?.posts?.length || 0
);

// Selector filtrato: restituisce il conteggio dei driver con isChild=false o undefined
export const getTotDrivers = createSelector(
  selectDriverFeature,
  (state) => state?.posts?.length || 0
);

// Selector completo: restituisce il conteggio di tutti i driver inclusi isChild=true
export const getTotDriversAllAssets = createSelector(
  selectDriverFeature,
  (state) => state?.posts?.length || 0
);

//#region [DASHBOARD SELECTORS]
export const getDashboards = createSelector(selectDashboards, (state) => state);

export const getSignalsData = createSelector(selectDashboardData, (state) => state.signalsData);

export const getKpiData = createSelector(selectDashboardData, (state) => state.kpiData);
export const getKpiVehicleStat = createSelector(selectDashboardData, (state) => state.compositeKpiData);

export const getMachineData = createSelector(
  selectDashboardData,
  (state) => state.machineData
);

export const getCompositeSignalData = createSelector(
  selectDashboardData,
  (state) => state.compositeSignalData
);

export const getSignalsCatalog = createSelector(
  selectDashboardData,
  (state) => state.signalsCatalog
);

export const getTableData = createSelector(
  selectDashboardData,
  (state) => state.tableData
);
//#endregion

//#region [LOADING DASHBOARD DATA SELECTORS]
export const isLoadingSignalsData = createSelector(
  selectDashboardData,
  (state) => state.loadingSignalsData
);

export const isLoadingKpiData = createSelector(
  selectDashboardData,
  (state) => state.loadingKpiData
);

export const isLoadingMachineData = createSelector(
  selectDashboardData,
  (state) => state.loadingMachineData
);

export const isLoadingCompositeSignalData = createSelector(
  selectDashboardData,
  (state) => state.loadingCompositeSignalData
);

export const isloadingCompositeKpiData = createSelector(
  selectDashboardData,
  (state) => state.loadingCompositeKpiData
);

export const isLoadingTableData = createSelector(
  selectDashboardData,
  (state) => state.loadingTableData
);
//#endregion
